import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
  template: `
    <div class="flex items-center justify-start text-aux-black">
      <div class="w-32 mr-4" *ngIf="params?.data?.logo">
        <img [alt]="params.data.name" [src]="params.data.logo" />
      </div>
      <div *ngIf="params?.data?.name">{{ params.data.name }}</div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgIntegrationsVendorComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  refresh(): boolean {
    return false;
  }

  async agInit(params: ICellRendererParams) {
    this.params = params;
  }
}
